export default "__VITE_ASSET__CeUt4xjG__"